import moment from 'moment-timezone';

import { EntityTypes } from '@common-types/Entities';

export { getSliderDates } from '../helpers';

export const getAvailability = (startDate, fetchAvailability, setValue, entityType) => {
  setValue('visitDate', startDate);
  if (!fetchAvailability) return;
  if (entityType === EntityTypes.TREATMENT || entityType === EntityTypes.FACILITY) {
    const requests = new Array(7)
      .fill('')
      .map((_, index) => fetchAvailability(moment(startDate).add(index, 'days')));
    Promise.all(requests).catch((err) => console.warn('Fetching availability failed: ', err));
  } else {
    fetchAvailability(startDate, moment(startDate).add(6, 'days'));
  }
};

export const startDateAfterChange = (
  startDate,
  setValue,
  changeJourneyParam,
  fetchAvailability,
  entityType
) => {
  setValue('visitDate', null);
  setValue('arrivalTime', null);
  changeJourneyParam('spaDate', startDate);
  getAvailability(startDate, fetchAvailability, setValue, entityType);
};

export const visitDayAfterChange = (visitDayDate, setValue, changeJourneyParam) => {
  setValue('arrivalTime', null);
  setValue('visitDate', visitDayDate);
  changeJourneyParam('spaDate', visitDayDate);
};
